import ControlPlanBase from './ControlPlanBase.vue';

export { ControlPlanBase }; 
